import React from 'react'
import { Route, Routes } from "react-router-dom";


export const Router = (props) => {
    const { routes, header, footer } = props;
    return (
        <div id="global_wrapper">
            {
                header ?
                    header
                :
                null
            }
            <div id="global_content" style={{paddingTop: "15px", paddingBottom: "15px"}} data-testid="content">
                <Routes>
                    {
                        routes.map((routeObj, key) => {
                            const { route, component, ...rest } = routeObj;
                            return (<Route key={key} path={route} element={component} {...rest} />)
                        })
                    }
                </Routes>
            </div>
            {
                footer ?
                    footer
                :
                null
            }
        </div>
    )
}
